import { useCallback } from 'react';

export const useGetFarmSnapshot = ({ farmSeasonId }: { farmSeasonId: number }) => {
    const getFarmSnapshot = useCallback(() => {
        return `${process.env.REACT_APP_API_BASE_URL}/v3/farm-seasons/${farmSeasonId}/snapshot`;
    }, [farmSeasonId]);

    return { getFarmSnapshot };
};
